import { Component, Input } from '@angular/core'
import { ActionType } from '../../../enum/landing-enum';
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'flowaccount-mobile-documents',
  templateUrl: './mobile-documents.component.html',
  styleUrl: './mobile-documents.component.scss',
})
export class MobileDocumentsComponent {
  @Input() heading: string
  @Input() contentDocuments: object[]
  public currentSlide = 1
  public actionTypeEnum = ActionType
  constructor(public translate: TranslateService) {}
  actionClickSlide(actionName: ActionType) {
    const slideListLength = this.contentDocuments?.length
    if (slideListLength) {
      if (actionName === ActionType.prev) {
        if (this.currentSlide === 1) {
          this.currentSlide = slideListLength
        } else {
          this.currentSlide -= 1
        }
      } else if (actionName === ActionType.next) {
        if (this.currentSlide === slideListLength) {
          this.currentSlide = 1
        } else {
          this.currentSlide += 1
        }
      }
    }
  }
}
